// Added locally (same pattern as `allowedZip`) because this app pins react-ui-components to a
// specific commit that doesn't know about `weeklySchedule` yet.
export const WEEKLY_SCHEDULE_SCHEMA = {
  type: "object",
  title: "Programación automática / Weekly Schedule",
  properties: {
    enabled: { type: "boolean" },
    paused: { type: "boolean" },
    weekdays: { type: "array", items: { type: "number" } },
    publishTime: { type: "string" },
    endTime: { type: "string" },
    timezone: { type: "string" },
    startDate: { type: "string" },
    repeatIndefinitely: { type: "boolean" },
    endDate: { type: "string" },
  },
}

// Places `weeklySchedule` directly under "Visible From" (or at the end when absent).
export const insertWeeklyScheduleProperty = (properties: Record<string, any>) => {
  const next: Record<string, any> = {}
  let inserted = false
  Object.entries(properties || {}).forEach(([key, value]) => {
    if (key === "weeklySchedule") return
    next[key] = value
    if (key === "visibleFrom") {
      next.weeklySchedule = WEEKLY_SCHEDULE_SCHEMA
      inserted = true
    }
  })
  if (!inserted) next.weeklySchedule = WEEKLY_SCHEDULE_SCHEMA
  return next
}
